import { bindActionCreators } from 'redux';
import { connect } from '../../../common/react-redux';
import { clearQtiImports } from '../../../common/actions/qtiImports';
import { qtiFileUpload } from '../../api/qtiImports';
import { CREATE_QTI_IMPORT, FILE_UPLOAD_URL_CALL, FILE_UPLOAD_CALL } from '@instructure/quiz-common';
import { ImportModal, progressValue } from '../../../common/components/ImportModal';
import t from '@instructure/quiz-i18n/format-message';
var callsToCheck = [CREATE_QTI_IMPORT, FILE_UPLOAD_CALL, FILE_UPLOAD_URL_CALL];

// Consuming Components must pass in qtiImportRecord, parentType, and parentId
export var mapStateToProps = function mapStateToProps(state, props) {
  var qtiImportRecord = props.qtiImport;
  var pv = progressValue(qtiImportRecord.progressNumber(), state.get('calls'), callsToCheck);
  return {
    failureMessage: qtiImportRecord.message || '',
    importMessage: t('QTI 1.2 and 2.x (.zip) files only'),
    progressValue: pv,
    acceptFileType: '.zip',
    importModalId: 'qtiImport'
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  var boundQtiFileUpload = bindActionCreators(qtiFileUpload, dispatch);
  return {
    onContinue: bindActionCreators(clearQtiImports, dispatch),
    fileUpload: function fileUpload(file, cancelAction) {
      boundQtiFileUpload(file, props.parentId, props.parentType, cancelAction, props.waitForAssignmentSettingsImported);
    }
  };
};
export var QTIImportModal = connect(mapStateToProps, mapDispatchToProps)(ImportModal);
export default QTIImportModal;